/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UseCaseDetail } from './UseCaseDetail';
import { UseCaseDetailFromJSON, UseCaseDetailFromJSONTyped, UseCaseDetailToJSON } from './UseCaseDetail';
import type { RiskDimension } from './RiskDimension';
import { RiskDimensionFromJSON, RiskDimensionFromJSONTyped, RiskDimensionToJSON } from './RiskDimension';
import type { ResidualRiskLabel } from './ResidualRiskLabel';
import {
  ResidualRiskLabelFromJSON,
  ResidualRiskLabelFromJSONTyped,
  ResidualRiskLabelToJSON,
} from './ResidualRiskLabel';
import type { RiskDimensionLabelDetail } from './RiskDimensionLabelDetail';
import {
  RiskDimensionLabelDetailFromJSON,
  RiskDimensionLabelDetailFromJSONTyped,
  RiskDimensionLabelDetailToJSON,
} from './RiskDimensionLabelDetail';
import type { RiskLabelCount } from './RiskLabelCount';
import { RiskLabelCountFromJSON, RiskLabelCountFromJSONTyped, RiskLabelCountToJSON } from './RiskLabelCount';

/**
 *
 * @export
 * @interface PublicUseCaseResponse
 */
export interface PublicUseCaseResponse {
  /**
   *
   * @type {UseCaseDetail}
   * @memberof PublicUseCaseResponse
   */
  useCase: UseCaseDetail;
  /**
   *
   * @type {Array<RiskDimensionLabelDetail>}
   * @memberof PublicUseCaseResponse
   */
  dimensionLabels: Array<RiskDimensionLabelDetail>;
  /**
   *
   * @type {Array<ResidualRiskLabel>}
   * @memberof PublicUseCaseResponse
   */
  residualRiskLabels: Array<ResidualRiskLabel>;
  /**
   *
   * @type {Array<RiskDimension>}
   * @memberof PublicUseCaseResponse
   */
  dimensionNames: Array<RiskDimension>;
  /**
   *
   * @type {Array<RiskLabelCount>}
   * @memberof PublicUseCaseResponse
   */
  riskLabelCounts: Array<RiskLabelCount> | null;
}

/**
 * Check if a given object implements the PublicUseCaseResponse interface.
 */
export function instanceOfPublicUseCaseResponse(value: object): value is PublicUseCaseResponse {
  if (!('useCase' in value) || value['useCase'] === undefined) return false;
  if (!('dimensionLabels' in value) || value['dimensionLabels'] === undefined) return false;
  if (!('residualRiskLabels' in value) || value['residualRiskLabels'] === undefined) return false;
  if (!('dimensionNames' in value) || value['dimensionNames'] === undefined) return false;
  if (!('riskLabelCounts' in value) || value['riskLabelCounts'] === undefined) return false;
  return true;
}

export function PublicUseCaseResponseFromJSON(json: any): PublicUseCaseResponse {
  return PublicUseCaseResponseFromJSONTyped(json, false);
}

export function PublicUseCaseResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicUseCaseResponse {
  if (json == null) {
    return json;
  }
  return {
    useCase: UseCaseDetailFromJSON(json['use_case']),
    dimensionLabels: (json['dimension_labels'] as Array<any>).map(RiskDimensionLabelDetailFromJSON),
    residualRiskLabels: (json['residual_risk_labels'] as Array<any>).map(ResidualRiskLabelFromJSON),
    dimensionNames: (json['dimension_names'] as Array<any>).map(RiskDimensionFromJSON),
    riskLabelCounts:
      json['risk_label_counts'] == null ? null : (json['risk_label_counts'] as Array<any>).map(RiskLabelCountFromJSON),
  };
}

export function PublicUseCaseResponseToJSON(value?: PublicUseCaseResponse | null): any {
  if (value == null) {
    return value;
  }
  return {
    use_case: UseCaseDetailToJSON(value['useCase']),
    dimension_labels: (value['dimensionLabels'] as Array<any>).map(RiskDimensionLabelDetailToJSON),
    residual_risk_labels: (value['residualRiskLabels'] as Array<any>).map(ResidualRiskLabelToJSON),
    dimension_names: (value['dimensionNames'] as Array<any>).map(RiskDimensionToJSON),
    risk_label_counts:
      value['riskLabelCounts'] == null ? null : (value['riskLabelCounts'] as Array<any>).map(RiskLabelCountToJSON),
  };
}
